import 'jquery';
import './_markerclusterer_compiled';

$(function () {
    window.map_center = { lat: 39.99, lng: -82.9833 };
    window.map_zoom = 11;

    // Grab the API key from the #google-maps-api-key span
    const apiKey = $('#google-maps-api-key').data('api-key');
    if (apiKey) {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMyHistoryMap`;
        script.async = true;
        document.head.appendChild(script);
    }
});

/**
 * Mapping section
 */

window.initMyHistoryMap = function () {
    window.map_center = { lat: 39.99, lng: -82.9833 };
    window.map_zoom = 11;
    window.map = new google.maps.Map(document.getElementById('myhistory-map'), {
        zoom: window.map_zoom,
        center: window.map_center,
    });
    window.clusterer = new MarkerClusterer(map);
    window.map_bounds = new google.maps.LatLngBounds();

    window.markers = {};

    getAndShowMyHistoryItems($('#myhistory-api-url').data('api-url'));

    jQuery('#myhistory-map-reset').bind('click', function () {
        clearMap();

        //kmlLayers.regions.setMap(map);
    });

    const sidebar = $('#myhistory-map-sidebar');

    if (sidebar.length > 0) {
        let sidebarClone = sidebar.clone();
        sidebar.remove();

        $('#myhistory-map > div').append(sidebarClone);
        $('#myhistory-map-sidebar-close').bind('click', hideMarkerInfo);
    }
};

function showMarkerInfo(marker) {
    $('#myhistory-map-sidebar-content').html(marker.content);
    $('#myhistory-map-sidebar').addClass('active');
}

function hideMarkerInfo() {
    $('#myhistory-map-sidebar-content').html('');
    $('#myhistory-map-sidebar').removeClass('active');
}

function clearMapBounds() {
    window.map_bounds = new google.maps.LatLngBounds();
}

function clearMap() {
    map.setCenter(map_center);
    map.setZoom(map_zoom);
    hideMarkerInfo();
}

function getNeighborhoodUrl(name) {
    if (window.neighborhood_urls && neighborhood_urls[name] != null) {
        return neighborhood_urls[name];
    } else {
        return 'https://digital-collections.columbuslibrary.org/digital/search';
    }
}

function getAndShowMyHistoryItems(url) {
    jQuery.getJSON(url, function (wrappedData) {
		showPins(wrappedData.data);

		if (wrappedData.links && wrappedData.links.next) {
			getAndShowMyHistoryItems(wrappedData.links.next);
		}
	});
}

function showPins(items) {
        // Geocode the addresses and add the pins to the map
        for (var i in items) {
            if (items[i].address) {
                items[i].url =
                    'https://digital-collections.columbuslibrary.org/digital/collection/' +
                    items[i].collection.replace(/^\//, '') +
                    '/id/' +
                    items[i].id;

                // If we already have lat/lng, add marker immediately; else ignore it
                if (items[i].coords) {
                    window.lastitems = items[i];
                    if (items[i].coords.lat == null) {
                        items[i].coords = { lat: items[i].coords[0], lng: items[i].coords[1] };
                    }
                    addMarker(items[i].coords, items[i].title, items[i].image, items[i].url);
                }
            }
        }
        window.map.fitBounds(window.map_bounds);

    return false;
}

function setNeighborhoodMapStatus(status, selector) {
    if (selector) {
        jQuery('#myhistory-map-status ' + selector).html(status);
    } else {
        jQuery('#myhistory-map-status').html(status);
    }
}

function incrementNeighborhoodMarkerCount() {
    var current = jQuery('#myhistory-map-status .loaded').html();
    setNeighborhoodMapStatus(++current, '.loaded');
}

function getMarkerContent(title, image, url) {
    return '<p><a href="' + url + '" target="_blank"><img src="' + image + '" /><br>' + title + '</a><p>';
}

function addMarker(coords, title, image, url) {
    var latlng = coords.lat + ',' + coords.lng;
    if (window.markers[latlng]) {
        incrementNeighborhoodMarkerCount();
        window.markers[latlng].content += getMarkerContent(title, image, url);
    } else {
        var marker = new google.maps.Marker({
            position: coords,
            title: title,
            //icon: '/img/icon-pin.png',
            image: image,
            url: url,
            content: getMarkerContent(title, image, url),
        });
        window.markers[latlng] = marker;
        window.clusterer.addMarker(marker);

        // Add event listener for clicking a marker
        google.maps.event.addListener(marker, 'click', function () {
            showMarkerInfo(marker);
        });
    }

    window.map_bounds.extend(new google.maps.LatLng(coords));
    // Make the map bounds (center and zoom) fit the pins
    //map.fitBounds(map_bounds);
}
